// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"HintConfirmationDisplay_hideOnMobile__k-u8g"};